import React from 'react';
import {RFValue} from 'react-native-responsive-fontsize';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {PPDebitoDTO} from '../../../../../../dtos/ProntoPagueiDTO';
import {
  parseBRValue,
  formatCurrency,
  getMonthFromVencimento,
  getVencimentoStatus,
} from '../../utils';
import {
  Item,
  LeftContent,
  CheckBox,
  Infos,
  Title,
  StatusBadge,
  RightContent,
  Value,
  ItemDate,
} from '../../styles';

interface DebitItemProps {
  item: PPDebitoDTO;
  isSelected: boolean;
  onPress: (item: PPDebitoDTO) => void;
}

export const DebitItem = React.memo(function DebitItem({
  item,
  isSelected,
  onPress,
}: DebitItemProps) {
  const status = getVencimentoStatus(item.vencimento);
  const month = getMonthFromVencimento(item.vencimento);

  return (
    <Item
      activeOpacity={item.required ? 1 : 0.7}
      onPress={() => onPress(item)}>
      <LeftContent>
        <CheckBox checked={isSelected} locked={item.required}>
          {item.required ? (
            <MaterialCommunityIcons
              name="check"
              size={RFValue(12)}
              color="#fff"
            />
          ) : isSelected ? (
            <MaterialCommunityIcons
              name="check"
              size={RFValue(14)}
              color="#fff"
            />
          ) : null}
        </CheckBox>
        <Infos>
          <Title numberOfLines={1}>{item.resumo || item.descricao}</Title>
          <StatusBadge status={status}>{status}</StatusBadge>
        </Infos>
      </LeftContent>
      <RightContent>
        <Value>{formatCurrency(parseBRValue(item.valor))}</Value>
        <ItemDate>{month}</ItemDate>
      </RightContent>
    </Item>
  );
});